function getAssetsDomain() {
    return isNonProd() || isShowcase()
        ? 'https://frontstagingstatssuperbetcom.freetls.fastly.net'
        : 'https://scorealarm-stats.freetls.fastly.net';
}
var nonProdInfixes = [
    'dev.',
    'qa.',
    'stage.',
];
function isNonProd() {
    var hostname = window.location.hostname;
    return nonProdInfixes.some(function (infix) { return hostname.startsWith(infix) || hostname.includes(".".concat(infix)); });
}
function isShowcase() {
    return window.location.hostname === 'design.superbet.com'
        || window.location.hostname === 'localhost' && window.location.port === '9090';
}

export { getAssetsDomain };
